import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {
  Notification,
    Pace
} from "components/Atoms";

import {Box, Container, MenuItem, FormGroup, FormControlLabel, Checkbox, TextField} from "@mui/material";
import PhotoUpload from "components/PhotoUpload";
import * as Actions         from "actions";
import HeaderBack from "components/elements/main/HeaderBack";
import CustomSectionCreator from "components/CustomSectionCreator";
import {H2, H4} from "components/CustomTypography";
import SelectFieldComponent from "components/SelectField";
import {getAdminShopLogReasonList, getAdminShopLogInterestList} from "helpers/utils";
import AdminShopSalesLogList from "components/elements/admin/shops/AdminShopSalesLogList";

const AdminAddSalesLogQuickMain = (props) => {

    const [interestState, setInterestState] = useState("");
    const [scopeState, setScopeState] = useState([]);
    const [messageState, setMessageState] = useState("");

    const {
        serviceError, reqStatus,
        isLoading, selectedShop, images, cancelEdit, saleslog,
        adminAddQuickSalesLogClicked, key, citiesList
    } = props;

    const {
        shop_id, title
    } = selectedShop;

    const sendNotification = (type, { title, description = "" }) => {
        Notification[type]({
            message: title,
            description,
        });
    };


    useEffect(() => {
        if (serviceError && reqStatus) {
            let feedback = {
                title: "Something went wrong!",
                description: serviceError.statusText,
            };
            sendNotification("error", feedback);
        }
    }, [serviceError, reqStatus]);

    const addImageCallback = (file) => {
        const formData = new FormData()
        formData.append("image", file);
        adminAddQuickSalesLogClicked(shop_id, messageState, interestState, scopeState, formData);
    }

    const scopeOptions = [
        { value: 'uploadphotos', label: 'Product - Uploaded Photos' },
        { value: 'priceset', label: 'Product - Set Prices' },
        { value: 'tryondemo', label: 'Demo - Try-On' },
        { value: 'ordersample', label: 'Demo - Sample Order' },
        { value: 'linkset', label: 'Instagram - Link Added' },
        { value: 'messagesent', label: 'WhatsApp - Message Sent' },
        { value: 'tryonpackage', label: 'Packages - Try-On Credits' },
        { value: 'videopackage', label: 'Packages - Video Shoot' },
        { value: 'messagepackage', label: 'Packages - Messaging Packages' },
        { value: 'wholesale', label: 'Wholesale - Retail Buying' },
        { value: 'standeedelivered', label: 'Standee - Delivered' },
        { value: 'apptraining', label: 'Other - App Training' },
        { value: 'videocall', label: 'Other - Video Call Training' },
        { value: 'changephone', label: 'Other - Change Mobile' },
        { value: 'shopclosed', label: 'Other - Shop Closed' },
    ];

    const handleScopeChange = (value) => {
        setScopeState(prev => 
            prev.includes(value) 
                ? prev.filter(v => v !== value)
                : [...prev, value]
        );
    };

    const shopLogInterest = getAdminShopLogInterestList();
    const inputInterestOptions = shopLogInterest.map((item) => {
        const { label, value } = item;
        return (
            <MenuItem value={value}>{label}</MenuItem>
        );
    });


    const handleShopLogInterest = (event) => {
        setInterestState(event.target.value);
    }

      return (
          <Container key={key}>
              <Box width="100%" >
                  <HeaderBack onCancel={() => cancelEdit()}/>
                  {<CustomSectionCreator isSubtle={true} title="Add Sales Log" /> }
              </Box>


              <Box width="100%" order={1} mt={4}>
                  <H2 mb={2} fontSize={14} ellipsis>
                      Customer Interest:
                  </H2>
              </Box>

              <SelectFieldComponent
                  sx={{margin: "4px"}}
                  required
                  options={inputInterestOptions}
                  label="Interest"
                  value={interestState}
                  onChange={(event) => handleShopLogInterest(event)}
              />

              <Box width="100%" order={1} mt={4}>
                  <H2 mb={2} fontSize={14} ellipsis>
                      Message (Optional):
                  </H2>
              </Box>

              <TextField
                  sx={{margin: "4px", mb: 2}}
                  fullWidth
                  multiline
                  rows={3}
                  label="Message"
                  placeholder="Enter a message or note about this sales log..."
                  value={messageState}
                  onChange={(event) => setMessageState(event.target.value)}
                  variant="outlined"
              />

              <Box width="100%" order={1} mt={4}>
                  <H2 mb={2} fontSize={14} ellipsis>
                      Scope of Work Done:
                  </H2>
              </Box>

              <FormGroup sx={{ margin: "4px", mb: 2 }}>
                  {scopeOptions.map((option) => (
                      <FormControlLabel
                          key={option.value}
                          control={
                              <Checkbox
                                  checked={scopeState.includes(option.value)}
                                  onChange={() => handleScopeChange(option.value)}
                                  size="small"
                              />
                          }
                          label={option.label}
                      />
                  ))}
              </FormGroup>

              <Box width="100%" order={1} mt={2}>
                  <H2 mb={1} fontSize={14} ellipsis>
                      Select photo after filling all details
                  </H2>
              </Box>

              <Box mb={2}>
                  <PhotoUpload
                      key={key}
                            isRemoveAllowed={false}
                            images={images}
                            addImageCallback={addImageCallback}
                            cancelEdit={cancelEdit}
                  />
              </Box>
              <AdminShopSalesLogList shopId={shop_id} />
          </Container>
      );
};

// Mapping Props and State.
const adminAddSalesLogQuickMain = connect(
    ({ adminShops, bootupInfo }) => ({
        bootupInfo: bootupInfo,
        reqStatus: adminShops.reqStatus,
        isLoading: adminShops.isLoading,
        serviceError: adminShops.serviceError,
    }),
    (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(AdminAddSalesLogQuickMain);

export { adminAddSalesLogQuickMain as default };
